<style scoped>
  .url-open-icon {
    color: rgba(255,255,255,.7);
    position: relative;
    font-size: 11px;
    top: -7px;
    left: -3px;
  }
</style>
<template>
  <div>
    <template
      v-for="menu in menuList"
    >
      <Submenu
        v-if="(menu.items&&menu.items.length)||!menu.path"
        v-show="showHashMap[menu.id]"
        :key="menu.id"
        :name="menu.id"
      >
        <template slot="title">
          <Icon
            v-if="menu.icon"
            :type="menu.icon"
            size="14"
          />
          <span class="layout-text">
            {{ menu.name }}
            <Badge
              v-if="menu.red_dot_token"
              :count="calculateCount(menu.red_dot_token,bageCount)"
            />
          </span>
        </template>
        <MenusItemSpecial
          :menu-list="menu.items"
          :show-hash-map="showHashMap"
          :bage-count="bageCount"
        />
      </Submenu>
      <Menu-item
        v-else
        v-show="showHashMap[menu.id]"
        :id="`menu-${menu.id}`"
        :key="menu.id"
        :name="menu.id"
      >
        <Icon
          v-if="menu.icon"
          :type="menu.icon"
          size="14"
        />
        {{ menu.name }}
        <v-icon
          v-if="menu.route_type === 'url-open'"
          class="url-open-icon"
        >
          mdi-share-all
        </v-icon>
        <Badge
          v-if="menu.red_dot_token"
          :count="bageCount[menu.red_dot_token]"
        />
      </Menu-item>
    </template>
  </div>
</template>
<script>
  export default {
    name:'MenusItemSpecial',
    props: {
      menuList:{
        type: Array,
        default: () => []
      },
      showHashMap:{
        type: Object,
        default:() => ({})
      },
      bageCount: {
        type: Object,
        default:() => ({})
      }
    },
    methods: {
      calculateCount(red_dot_token, bageCount) {
        if (typeof red_dot_token === 'string') {
          return bageCount[red_dot_token]
        }
        return red_dot_token.reduce((total, key) => {
          return total + (bageCount[key] || 0)
        }, 0)
      }
    }
  }
</script>
